export default __webpack_public_path__ + "static/Black_Pearl-9b88de4b61ef119d09da45080168fd6e.png";